/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B050010 仕入入力(本社業務)
 */

import { Column } from "@material-table/core";
import { Box } from "@mui/material";
import Big from "big.js";
import {
  B000111Biko,
  B000111Meisaibiko,
  B050010HandleChangeShohinCd,
  B050010Shohin,
  B050010Shain,
  B050010Shire,
  B050010Tanka,
  B050010ZeiRitsu,
  B050010Kanosu,
  B050020GetResponse,
  B050010Create,
  B050010Update,
  B050010Delete,
  catchRestError,
  B050010DeleteRequest,
  B050010UchiwakeKbn,
  B000190SokoNmrSokoshubetsuKbn,
} from "clients/rest";
import {
  msgState,
  SCancelButton,
  SCodeSelect,
  SConfirmDialog,
  SConfirmDialogAction,
  SDateField,
  SEntryTab,
  SFrame,
  SLabel,
  SNormalButton,
  SNumberField,
  STable,
  STextField,
} from "components";
import { getClientError, getClientMessage } from "messages";
import { ChohaKbn, getSCode, SCode, ShireUchiwakeKbn } from "messages/codes";
import { labels } from "messages/labels";
import { B000111, B000140, B000170, B000190, B000200, B000220 } from "pages";
import { createRef, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { date, validDate } from "services";
import { digit } from "services/CalcService";
import {
  editKbn,
  meishoKbn,
  shireUchiwakeKbn,
  shohinShokuchiKbn,
  shokuchiKbn,
  sokoshubetsuKbn,
  tenyuryokuKbn,
} from "services/codes";
import { focusState, useFocus } from "states";

export type B050010InputData = {
  editKbn: string;
  shire: B050020GetResponse[];
};

// 呼び出し時のプロパティ
type Props = Partial<{}>;

// フィールド定義
type Fields = Partial<{
  editKbn: string;
  shiredenpyoNo: string;
  shiredenpyoNoF: string;
  juchudenpyoNo: string;
  shireYmd: string;
  shireCd: string;
  shireNm: string;
  shainCd: string;
  shainNm: string;
  bumonCd: string;
  bumonNm: string;
  bikoCd: string;
  biko: string;
  bikoCdBefore: string;
  chohaKbn: SCode;
  shireKinGokei: string;
  zeiKinGokei: string;
  gokei: string;
  getsujiYmd: string;
  zeiRitsu: string;
  shireshokuchiKbn: number;
  eigyoCd: string;
  version: string;
  dirtyFields: {
    shireYmd: string;
    shireCd: string;
    shainCd: string;
  };
}>;

// 明細データ
type MeiData = Partial<{
  shiregyoNo: number;
  uchiwakeKbn: SCode;
  shohinCd: string;
  shohinshokuchiKbn: number;
  sokoCd: string;
  sokoNm: string;
  sokoshubetsuKbn: number;
  shiresu: string;
  basetanka: string;
  shiretanka: string;
  shireKin: string;
  tenyuryokuKbn: number;
  kasanfugo: number;
  shohinNm: string;
  meisaibikoCd: string;
  meisaibiko: string;
  meisaibikoCdBefore: string;
  kanosu: string;
  dirtyFields: {
    shohinCd: string;
    sokoCd: string;
    shiresu: string;
    shiretanka: string;
  };
}>;

// 明細テーブルデータ定義
type Data = Partial<{
  shiregyoNo: number;
  juchudenpyoNo: string;
  juchugyoNo: string;
  hachugyoNo: string;
  uchiwakeKbn: string;
  uchiwakeKbnView: string;
  kasanfugo: number;
  shohinCd: string;
  shohinshokuchiKbn: number;
  shohinNm: string;
  shiresu: string;
  shiretanka: string;
  basetanka: string;
  shireKin: string;
  tenyuryokuKbn: number;
  sokoCd: string;
  sokoNm: string;
  sokoshubetsuKbn: number;
  meisaibikoCd: string;
  meisaibiko: string;
  meisaibikoCdBefore: string;
  kazeiKbn: string;
}>;

// フィールド初期値
const defaultFields: Fields = {
  editKbn: editKbn.register,
  shiredenpyoNo: "",
  shiredenpyoNoF: "",
  juchudenpyoNo: "",
  shireYmd: date(),
  shireCd: "",
  shireNm: "",
  shainCd: "",
  shainNm: "",
  bumonCd: "",
  bumonNm: "",
  bikoCd: "",
  biko: "",
  bikoCdBefore: "",
  chohaKbn: getSCode(ChohaKbn, "0"),
  shireKinGokei: "",
  zeiKinGokei: "",
  gokei: "",
  getsujiYmd: "",
  zeiRitsu: "",
  shireshokuchiKbn: undefined,
  eigyoCd: "",
  version: "",
  dirtyFields: {
    shireYmd: date(),
    shireCd: "",
    shainCd: "",
  },
};

// 明細フィールド初期値
const meiDefaultFields: ShireMeiFields = {
  meiTab: true,
  uchiwakeKbn: getSCode(ShireUchiwakeKbn, "0"),
  shohinCd: "",
  shohinshokuchiKbn: undefined,
  sokoCd: "",
  sokoNm: "",
  sokoshubetsuKbn: undefined,
  shiresu: "",
  shiretanka: "",
  shireKin: "",
  tenyuryokuKbn: undefined,
  kasanfugo: undefined,
  shohinNm: "",
  meisaibikoCd: "",
  meisaibiko: "",
  meisaibikoCdBefore: "",
  kanosu: "",
  dirtyFields: {
    shohinCd: "",
    sokoCd: "",
    shiresu: "",
    shiretanka: "",
  },
};

// テーブル設定
const columns: Column<Data>[] = [
  { field: "shiregyoNo", title: "行　", width: "4rem", align: "right" },
  {
    field: "uchiwakeKbnView",
    title: "区分",
    width: "5rem",
    render: (data) => {
      return getSCode(ShireUchiwakeKbn, data.uchiwakeKbn ?? "0")?.label;
    },
  },
  { field: "shohinCd", title: "商品コード", width: "7rem" },
  { field: "shohinNm", title: "商品名", width: "15rem" },
  {
    field: "shiresu",
    title: "仕入数　",
    width: "6rem",
    align: "right",
    render: (data) => digit(data.shiresu),
  },
  {
    field: "shiretanka",
    title: "仕入単価　",
    width: "6rem",
    align: "right",
    render: (data) => {
      let backgroundColor = "inherit";
      if (data.tenyuryokuKbn === tenyuryokuKbn.exists) {
        backgroundColor = "#FFFF00";
      }
      return <Box sx={{ backgroundColor }}>{digit(data.shiretanka)}</Box>;
    },
  },
  {
    field: "shireKin",
    title: "金額　",
    width: "6rem",
    align: "right",
    render: (data) => digit(data.shireKin),
  },
  { field: "sokoCd", title: "倉庫コード", width: "6rem" },
  { field: "sokoNm", title: "倉庫名", width: "10rem" },
  { field: "meisaibiko", title: "仕入明細備考", width: "15rem" },
  { field: "juchudenpyoNo", hidden: true },
  { field: "juchugyoNo", hidden: true },
  { field: "uchiwakeKbn", title: "内訳区分", hidden: true },
  { field: "shohinshokuchiKbn", title: "諸口区分", hidden: true },
  { field: "basetanka", hidden: true },
  { field: "tenyuryokuKbn", hidden: true },
  { field: "sokoshubetsuKbn", hidden: true },
  { field: "meisaibikoCdBefore", hidden: true },
  { field: "kazeiKbn", hidden: true },
];

//明細入力部
export type ShireMeiFields = MeiData &
  Partial<{
    meiTab: boolean;
  }>;

// 加算符号の値
const kasanfugoPlus: number = 1;
const kasanfugoMinus: number = -1;

const focusId = "B050010";

// B050010 仕入入力(本社業務)
export const B050010 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};

const Page = (props: Props) => {
  // 初期設定
  // テーブル管理
  const tableRef = createRef();
  const [rows, setRows] = useState<Data[]>([]);
  const [rowCount, setRowCount] = useState(0);
  // テーブル行で選択されたデータ
  const [rowData, setRowData] = useState<Partial<Data>>();
  // フォーム関数
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });
  const meiMethods = useForm<ShireMeiFields>({
    mode: "onBlur",
    defaultValues: meiDefaultFields,
  });

  // dirtyFields初期化
  const resetDirtyFields = () => {
    const fields = methods.getValues();
    methods.setValue("dirtyFields.shireYmd", fields.shireYmd ?? "");
    methods.setValue("dirtyFields.shireCd", fields.shireCd ?? "");
    methods.setValue("dirtyFields.shainCd", fields.shainCd ?? "");
  };
  const resetMeiDirtyFields = () => {
    const fields = meiMethods.getValues();
    meiMethods.setValue("dirtyFields.shohinCd", fields.shohinCd ?? "");
    meiMethods.setValue("dirtyFields.sokoCd", fields.sokoCd ?? "");
    meiMethods.setValue("dirtyFields.shiresu", fields.shiresu ?? "");
    meiMethods.setValue("dirtyFields.shiretanka", fields.shiretanka ?? "");
  };

  const reRendering = () => {
    resetDirtyFields();
    resetMeiDirtyFields();
  };

  // SCodeの値
  const [kasanfugoPlusList, setKasanfugoPlusList] = useState<number[]>([]);

  // フォーカス設定
  const { focus, register } = useRecoilValue(focusState(focusId));
  // 遷移元データ取得用
  const navigate = useNavigate();
  const location = useLocation();
  const inputData = location.state as B050010InputData;
  // メッセージ表示
  const setMsg = useSetRecoilState(msgState);
  // 登録ボタンクリック時に出す確認ダイアログオープン用
  const [openCreateConfirm, setOpenCreateConfirm] = useState(false);
  // 更新ボタンクリック時に出す確認ダイアログオープン用
  const [openUpdateConfirm, setOpenUpdateConfirm] = useState(false);

  // 活性設定
  // 参照モードかどうか
  const isReference = methods.watch("editKbn") === editKbn.reference;
  // 修正モードかどうか
  const isUpdate = methods.watch("editKbn") === editKbn.update;
  // 仕入先.諸口が「1：諸口」かどうか
  const isShireShokuchi =
    methods.watch("shireshokuchiKbn") === shokuchiKbn.shokuchi;
  // 商品.諸口区分が「1:諸口」かどうか
  const isShohinShokuchiKbn =
    meiMethods.watch("shohinshokuchiKbn") === shohinShokuchiKbn.shokuchi;
  // ベース単価、発注単価が一致するかどうか(手入力発注区分)
  const isTenyuryokushireKbn =
    Number(meiMethods.watch("basetanka")) ===
    Number(meiMethods.watch("shiretanka"));
  // ボタンの活性・非活性
  const [disabledDeleteDetail, setDisabledDeleteDetail] = useState(true);

  // 初期表示(編集・参照時の設定)
  useEffect(() => {
    // unregisterを使用する値をresetで初期化(defalutValueが無視され、初期値にundifindが設定されることがあるため)
    methods.reset();
    methods.reset({
      ...methods.getValues(),
      shireCd: "",
    });
    meiMethods.reset();
    meiMethods.reset({
      ...meiMethods.getValues(),
      shohinCd: "",
    });

    if (inputData === null) {
      return;
    }
    // 編集区分の設定
    methods.setValue("editKbn", inputData.editKbn);

    // 入力プロパティの反映
    const shire = inputData.shire;
    if (typeof shire === "undefined") return;
    // 仕入データ設定
    // ヘッダ部
    methods.setValue("shiredenpyoNo", inputData.shire[0].shiredenpyoNo ?? "");
    methods.setValue("shiredenpyoNoF", inputData.shire[0].shiredenpyoNoF ?? "");
    methods.setValue("juchudenpyoNo", inputData.shire[0].juchudenpyoNo ?? "");
    methods.setValue("shireYmd", inputData.shire[0].shireYmd ?? "");
    methods.setValue("shireCd", inputData.shire[0].shireCd ?? "");
    methods.setValue("shireNm", inputData.shire[0].shireNm ?? "");
    methods.setValue(
      "shireshokuchiKbn",
      Number(inputData.shire[0].shireshokuchiKbn)
    );
    methods.setValue("eigyoCd", inputData.shire[0].eigyoCd ?? "");
    methods.setValue("shainCd", inputData.shire[0].shainCd ?? "");
    methods.setValue("shainNm", inputData.shire[0].shainNm ?? "");
    methods.setValue("bumonCd", inputData.shire[0].bumonCd ?? "");
    methods.setValue("bumonNm", inputData.shire[0].bumonNm ?? "");
    methods.setValue(
      "chohaKbn",
      getSCode(ChohaKbn, inputData.shire[0].chohaKbn ?? "0")
    );
    methods.setValue("bikoCd", inputData.shire[0].bikoCd ?? "");
    methods.setValue("biko", inputData.shire[0].biko ?? "");
    methods.setValue("bikoCdBefore", inputData.shire[0].bikoCd ?? "");
    methods.setValue("getsujiYmd", inputData.shire[0].getsujiYmd ?? "");
    methods.setValue("version", inputData.shire[0].version ?? "");
    methods.setValue("shireKinGokei", inputData.shire[0].shireKinGokei ?? "");
    methods.setValue("zeiKinGokei", inputData.shire[0].zeiKinGokei ?? "");
    methods.setValue("gokei", inputData.shire[0].gokei ?? "");
    methods.setValue("zeiRitsu", inputData.shire[0].shohizeiritsu ?? "");

    // 明細部
    const gridDataList = inputData.shire.map<Data>((value) => {
      const mei: Data = {
        shiregyoNo: value.shiregyoNo ?? undefined,
        hachugyoNo: value.hachugyoNo ?? "",
        juchugyoNo: value.juchugyoNo ?? "",
        uchiwakeKbn: value.uchiwakeKbn ?? "",
        uchiwakeKbnView: getSCode(ShireUchiwakeKbn, value.uchiwakeKbn)?.label,
        kasanfugo: value.kasanfugo ?? undefined,
        shohinCd: value.shohinCd ?? "",
        shohinshokuchiKbn: value.shohinshokuchiKbn ?? "",
        shohinNm: value.shohinNm ?? "",
        shiresu: value.shiresu ?? "",
        tenyuryokuKbn: Number(value.tenyuryokuKbn) ?? "",
        basetanka: value.basetanka ?? "",
        shiretanka: value.shiretanka ?? "",
        shireKin: value.shireKin ?? "",
        sokoCd: value.sokoCd ?? "",
        sokoNm: value.sokoNm ?? "",
        sokoshubetsuKbn: Number(value.sokoshubetsuKbn) ?? "",
        meisaibikoCd: value.meisaibikoCd ?? "",
        meisaibiko: value.meisaibiko ?? "",
        meisaibikoCdBefore: value.meisaibikoCd ?? "",
        kazeiKbn: value.kazeiKbn ?? "",
      };
      return mei;
    });
    // テーブルに反映
    setRows(gridDataList);
    reRendering();
  }, []);

  // 初期表示(共通)
  useEffect(() => {
    (async () => {
      // 消費税取得
      await B050010ZeiRitsu(methods);

      // 内訳区分リスト取得
      await B050010UchiwakeKbn(setKasanfugoPlusList, navigate, setMsg);

      meiMethods.setValue("uchiwakeKbn", getSCode(ShireUchiwakeKbn, "0"));

      // フォーカス
      focus(1);
    })();
  }, []);

  // 明細変更
  useEffect(() => {
    // 合計金額算出
    handleGokeiCalculating();
    reRendering();
  }, [rows]);

  // 仕入日変更時
  const handleChangeShireYmd = (
    shireYmd: string = methods.getValues().shireYmd!
  ) => {
    if (shireYmd === methods.getValues().dirtyFields?.shireYmd) return;
    if (shireYmd === "" || !validDate(shireYmd!)) return;

    (async () => {
      // 消費税取得
      await B050010ZeiRitsu(methods);

      // 明細入力部の単価再設定
      reacquisitionMeiTanka();

      // 明細が登録されている場合
      if (rows.length > 0) {
        // 明細再設定
        // 仕入単価が変更されていない商品コードを取得(重複排除)
        const shohinCdList: string[] = Array.from(
          new Set(
            rows
              // 手入力区分をチェック
              .filter((row) => row.tenyuryokuKbn === tenyuryokuKbn.none)
              // 内訳区分をチェック
              .filter((row) => row.uchiwakeKbn !== shireUchiwakeKbn.nebiki)
              .map((row) => row.shohinCd!)
          )
        );

        // 再設定する行が存在する場合
        if (shohinCdList.length > 0) {
          for (const shohinCd of shohinCdList) {
            B050010Tanka(methods, shohinCd, rows, navigate, setMsg, setRows);
          }
        }
        // 再設定する行が存在しない場合
        else {
          // 合計値(rowsに変更が無いため、明示的に処理を呼ぶ)
          handleGokeiCalculating();
        }
      }
      reRendering();
    })();
  };

  // 明細入力部の単価再設定
  const reacquisitionMeiTanka = () => {
    // フォームのデータを取得する。
    const meiFields = meiMethods.getValues();
    // 明細入力部が設定されていない場合(商品コードで判断)
    if (meiFields.shohinCd === undefined) return;

    // 手入力区分が「1:あり」の場合
    if (meiFields.tenyuryokuKbn === tenyuryokuKbn.exists) return;

    // 内訳区分が「2:値引」の場合
    if (meiFields.uchiwakeKbn?.value === shireUchiwakeKbn.nebiki) return;

    // 商品関連項目表示処理を行う
    B050010Shohin(methods, meiMethods, navigate, setMsg);
    reRendering();
  };

  // タブ切替
  const handleChangeMeiTab = () => {
    if (!meiMethods.watch("meiTab")) return;
    meiMethods.reset();
    meiMethods.reset({
      ...meiMethods.getValues(),
      shohinCd: "",
    });
    meiMethods.setValue("uchiwakeKbn", getSCode(ShireUchiwakeKbn, "0"));
    meiMethods.setValue("meiTab", true);
    setDisabledDeleteDetail(true);
  };

  //  ダイアログ表示用（登録）
  const handleOpenCreateConfirm = () => {
    if (meiMethods.formState.isDirty) {
      setOpenCreateConfirm(true);
    } else {
      handleClickCreateButton();
    }
  };

  //  ダイアログ表示用（更新）
  const handleOpenUpdateConfirm = () => {
    if (meiMethods.formState.isDirty) {
      setOpenUpdateConfirm(true);
    } else {
      handleClickUpdateButton();
    }
  };

  // キャンセル押下時（登録）
  const handleCancelCreateConfirm = () => {
    setOpenCreateConfirm(false);
  };
  // キャンセル押下時（更新）
  const handleCancelUpdateConfirm = () => {
    setOpenUpdateConfirm(false);
  };

  // 登録
  const handleClickCreateButton = () => {
    setOpenCreateConfirm(false);

    B050010Create(methods, rows)
      .then((response) => {
        methods.reset();
        methods.reset({
          ...methods.getValues(),
          shireCd: "",
        });
        meiMethods.reset();
        meiMethods.reset({
          ...meiMethods.getValues(),
          shohinCd: "",
        });

        setRows([]);

        (async () => {
          // 消費税取得
          await B050010ZeiRitsu(methods);
          setMsg(getClientMessage("B050010_001", response.data.shiredenpyoNo));
          reRendering();
        })();
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // 更新
  const handleClickUpdateButton = () => {
    setOpenUpdateConfirm(false);

    B050010Update(methods, rows)
      .then(() => {
        methods.reset();
        methods.reset({
          ...methods.getValues(),
          shireCd: "",
        });
        meiMethods.reset();
        meiMethods.reset({
          ...meiMethods.getValues(),
          shohinCd: "",
        });

        setRows([]);

        (async () => {
          // 消費税取得
          await B050010ZeiRitsu(methods);
          setMsg(getClientMessage("B050010_002"));
          reRendering();
        })();
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // 明細登録
  const handleClickCreateMeiButton = () => {
    // 独自チェック
    if (meiInvalidated()) return;

    // フィールドチェック
    meiMethods.handleSubmit(() => {
      // 明細に設定するデータを取得
      const shiregyoNo: number = rows.length + 1;
      const data: Data = handleDataMapping(shiregyoNo);
      // 明細を設定
      setRows([...rows, data]);
      setRowCount(shiregyoNo);

      // 明細クリア
      meiMethods.reset();
      meiMethods.reset({
        ...meiMethods.getValues(),
        shohinCd: "",
      });

      // 明細削除ボタン非活性
      setDisabledDeleteDetail(true);

      focus(8);
      reRendering();
    })();
  };

  // 明細更新
  const handleClickUpdateMeiButton = () => {
    console.log(methods.getValues().shireYmd);
    // 独自チェック
    if (meiInvalidated()) return;

    // フィールドチェック
    meiMethods.handleSubmit(() => {
      const shiregyoNo: number = rowData?.shiregyoNo!;
      // 明細に設定するデータを取得
      const data: Data = handleDataMapping(shiregyoNo);
      // 明細を設定
      rows[shiregyoNo - 1] = data;
      setRows([...rows]);

      // 明細クリア
      meiMethods.reset();
      meiMethods.reset({
        ...meiMethods.getValues(),
        shohinCd: "",
      });

      // 明細削除ボタン非活性
      setDisabledDeleteDetail(true);
      reRendering();
    })();
  };

  // 明細入力部の入力チェック
  const meiInvalidated = (): boolean => {
    // フォームのデータを取得する。
    const meiFields = meiMethods.getValues();

    // ☆内訳区分をチェック
    // 1. 内訳区分が 2：値引以外の場合
    if (meiFields.uchiwakeKbn?.value !== shireUchiwakeKbn.nebiki) {
      // shiresu , shiretanka が未入力の場合、エラー表示し、処理を中止する。
      if (meiFields.shiresu === "") {
        setMsg(getClientError("B050010_001"));
        return true;
      }
      if (meiFields.shiretanka === "") {
        setMsg(getClientError("B050010_002"));
        return true;
      }
      // 1. 内訳区分が 2：値引の場合
    } else if (meiFields.uchiwakeKbn?.value === shireUchiwakeKbn.nebiki) {
      // shiresu , shiretanka が入力済の場合、エラー表示し、処理を中止する。
      if (meiFields.shiresu !== "") {
        setMsg(getClientError("B050010_003"));
        return true;
      }
      if (meiFields.shiretanka !== "") {
        setMsg(getClientError("B050010_004"));
        return true;
      }
    }

    // ☆可能数をチェック
    let torihikisu: Big = new Big(0);

    // 内訳区分が 10：通常返品の場合、下記のように設定する。
    if (meiFields.uchiwakeKbn?.value === shireUchiwakeKbn.tujoHen) {
      // 取引数 = 仕入数 * -1
      torihikisu = new Big(meiFields.shiresu!).times(-1);

      // 内訳区分が 10：通常返品の以外の場合、下記のように設定する。
    } else if (meiFields.uchiwakeKbn?.value !== shireUchiwakeKbn.tujoHen) {
      // 取引数 = 仕入数
      torihikisu = new Big(meiFields.shiresu!);
    }

    // 取引数が 0 より小さい場合
    if (torihikisu < new Big(0)) {
      // sokoCd,shohinCd を渡して B050010/get/kanosu を呼び出す。
      B050010Kanosu(meiMethods, navigate, setMsg);

      // 取引数 + 返却値（可能数）が 0 よりも小さい場合。エラー表示し、処理を中止する。
      if (torihikisu.plus(new Big(meiFields.kanosu!)) < new Big(0)) {
        setMsg(getClientError("B050010_005"));
        return true;
      }
    }

    // sokoshubetsuKbn が 5(その他倉庫)ではない場合
    if (meiFields.sokoshubetsuKbn !== sokoshubetsuKbn.othersSoko) {
      setMsg(getClientError("B050010_006"));
      return true;
    }

    return false;
  };

  // 明細のデータマッピング;
  const handleDataMapping = (shiregyoNo: number): Data => {
    // フォームのデータを取得する。
    const meiFields = meiMethods.getValues();

    // 加算符号の設定
    // 内訳区分の選択値が「1:プラス」かどうか
    const isKasanfugoPlus: boolean = kasanfugoPlusList.some(
      (kasanfugoPlus) => kasanfugoPlus === Number(meiFields.uchiwakeKbn?.value)
    );
    let kasanfugo: number;
    // 加算符号がプラスの場合
    if (isKasanfugoPlus) {
      kasanfugo = kasanfugoPlus;
    } else {
      // 加算符号がマイナスの場合
      kasanfugo = kasanfugoMinus;
    }

    const data: Data = {
      shiregyoNo,
      uchiwakeKbnView: meiFields.uchiwakeKbn?.label,
      uchiwakeKbn: meiFields.uchiwakeKbn?.value,
      kasanfugo,
      shohinCd: meiFields.shohinCd,
      shohinNm: meiFields.shohinNm,
      shohinshokuchiKbn: meiFields.shohinshokuchiKbn,
      sokoCd: meiFields.sokoCd,
      sokoNm: meiFields.sokoNm,
      sokoshubetsuKbn: meiFields.sokoshubetsuKbn,
      shiresu: meiFields.shiresu,
      // 手入力発注区分の設定(一致する場合「0：変更なし」、一致しない場合「1：変更あり」)
      tenyuryokuKbn: isTenyuryokushireKbn
        ? tenyuryokuKbn.none
        : tenyuryokuKbn.exists,
      basetanka: meiFields.basetanka,
      shiretanka: meiFields.shiretanka,
      shireKin: meiFields.shireKin,
      meisaibikoCd: meiFields.meisaibikoCd,
      meisaibiko: meiFields.meisaibiko,
      meisaibikoCdBefore: meiFields.meisaibikoCdBefore,
    };

    return data;
  };

  // 仕入削除イベント
  const handleClickDeleteButton = () => {
    // フォームのデータを取得する。
    const fields = methods.getValues();
    // リクエスト作成
    const param: B050010DeleteRequest = {
      shiredenpyoNo: fields.shiredenpyoNo,
    };
    // API呼び出し
    B050010Delete(param)
      .then(() => {
        methods.reset();
        methods.reset({
          ...methods.getValues(),
          shireCd: "",
        });
        meiMethods.reset();
        meiMethods.reset({
          ...meiMethods.getValues(),
          shohinCd: "",
        });
        setRows([]);
        setMsg(getClientMessage("B050010_003"));
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // 明細削除
  const handleClickDeleteMeiButton = () => {
    // 選択行の取得
    if (typeof rowData?.shiregyoNo === "undefined") return;
    const shiregyoNo: number = rowData.shiregyoNo;
    // 対象の行を削除
    const newRows = rows
      .filter(function (source: Data) {
        return source.shiregyoNo !== shiregyoNo;
      })
      // 明細の連番の振り直し
      .map((meiRow: any, index) => {
        // 明細
        meiRow.shiregyoNo = ++index;
        return meiRow;
      });

    setRows(newRows);

    // 行選択の解除
    setRowData(undefined);

    // 明細クリア
    meiMethods.reset();
    meiMethods.reset({
      ...meiMethods.getValues(),
      shohinCd: "",
    });

    // 明細削除ボタン非活性
    setDisabledDeleteDetail(true);

    // 明細入力部を新規登録に変更する
    meiMethods.setValue("meiTab", true);
    reRendering();
  };

  //合計金額算出
  const handleGokeiCalculating = () => {
    // 明細が設定されていない場合
    if (rows.length === 0) {
      // 合計金額の初期化のみ行う
      methods.setValue("shireKinGokei", "");
      methods.setValue("zeiKinGokei", "");
      methods.setValue("gokei", "");
      return;
    }

    // フォームのデータを取得する。
    const fields = methods.getValues();

    // 仕入金額合計
    const shireKinGokei: Big = rows.reduce((acc: Big, row: Data): Big => {
      return acc.plus(
        new Big(row.shireKin ? row.shireKin : "0").times(
          new Big(row.kasanfugo ? row.kasanfugo : kasanfugoPlus)
        )
      );
    }, new Big("0"));

    // 消費税合計
    let zeiKinGokei: Big = new Big(0);
    zeiKinGokei = shireKinGokei
      .times(new Big(fields.zeiRitsu ? fields.zeiRitsu : "0"))
      .div(new Big("100"))
      .round(0, Big.roundDown);

    // 合計
    const gokei: Big = shireKinGokei.plus(zeiKinGokei);

    methods.setValue("shireKinGokei", shireKinGokei.toString());
    methods.setValue("zeiKinGokei", zeiKinGokei.toString());
    methods.setValue("gokei", gokei.toString());
  };

  // テーブル行ダブルクリックイベント
  const handleDoubleClickTableRow = (data: Data) => {
    // データを保存
    setRowData(data);
    if (typeof data.shiregyoNo !== "undefined") {
      // 明細入力部を編集に変更する
      meiMethods.setValue("meiTab", false);
      // 明細削除ボタンを活性化
      setDisabledDeleteDetail(false);
      // 明細入力部に値を設定する
      meiMethods.setValue("shiregyoNo", data.shiregyoNo);
      meiMethods.setValue(
        "uchiwakeKbn",
        getSCode(ShireUchiwakeKbn, data.uchiwakeKbn ?? "0")
      );
      meiMethods.setValue("kasanfugo", data.kasanfugo);
      meiMethods.setValue("shohinCd", data.shohinCd);
      meiMethods.setValue("shohinNm", data.shohinNm);
      meiMethods.setValue("shohinshokuchiKbn", data.shohinshokuchiKbn);
      meiMethods.setValue("sokoCd", data.sokoCd);
      meiMethods.setValue("sokoNm", data.sokoNm);
      meiMethods.setValue("sokoshubetsuKbn", data.sokoshubetsuKbn);
      meiMethods.setValue("shiresu", data.shiresu);
      meiMethods.setValue("tenyuryokuKbn", data.tenyuryokuKbn);
      meiMethods.setValue("basetanka", data.basetanka);
      meiMethods.setValue("shiretanka", data.shiretanka);
      meiMethods.setValue("shireKin", data.shireKin);
      meiMethods.setValue("meisaibikoCd", data.meisaibikoCd);
      meiMethods.setValue("meisaibiko", data.meisaibiko);
      meiMethods.setValue("meisaibikoCdBefore", data.meisaibikoCdBefore);
      focus(8);
      reRendering();
    }
  };

  // 内訳区分変更時
  const handleChangeUchiwakeKbn = () => {
    // ヘッダ部.希望納期を明細入力部に設定
    const { uchiwakeKbn } = meiMethods.getValues();
    // 明細入力欄を全て初期化する。
    meiMethods.reset();
    meiMethods.reset({
      ...meiMethods.getValues(),
      shohinCd: "",
    });
    meiMethods.setValue(
      "uchiwakeKbn",
      getSCode(ShireUchiwakeKbn, uchiwakeKbn?.value!)
    );
    reRendering();
  };

  // 仕入金計算
  const handleCalcShireKin = () => {
    const meiFields = meiMethods.getValues();
    const { uchiwakeKbn } = meiMethods.getValues();

    if (meiFields.shiretanka === "") {
      meiMethods.setValue("shireKin", "");
      return;
    }

    // 内訳区分が2:値引以外のとき
    if (uchiwakeKbn?.value !== shireUchiwakeKbn.nebiki) {
      // shiresu と shiretanka が null ではない場合
      if (meiFields.shiresu !== null && meiFields.shiretanka !== null) {
        // shireKin に設定する。shiresu × shiretanka
        const calcShireKin: Big = new Big(meiFields.shiresu!)
          .times(new Big(meiFields.shiretanka!))
          .round(0, Big.roundDown);
        meiMethods.setValue("shireKin", calcShireKin.toString());
      }
    }
    reRendering();
  };

  // 仕入先変更
  const handleChangeShire = () => {
    const fields = methods.getValues();
    if (fields.shireCd === fields.dirtyFields?.shireCd) {
      return;
    }

    if (fields.shireCd === "") {
      methods.setValue("shireNm", "");
      methods.setValue("shainCd", "");
      methods.setValue("shainNm", "");
      methods.setValue("bumonCd", "");
      methods.setValue("bumonNm", "");
      methods.setValue("shireshokuchiKbn", undefined);
      reRendering();
      return;
    }

    (async () => {
      await B050010Shire(methods, navigate, setMsg);
      reRendering();
    })();
  };

  // 仕入担当者変更
  const handleChangeShain = () => {
    const fields = methods.getValues();
    if (fields.shainCd === fields.dirtyFields?.shainCd) {
      return;
    }
    (async () => {
      await B050010Shain(methods, navigate, setMsg);
      reRendering();
    })();
  };

  // 備考変更
  const handleChangeBiko = () => {
    (async () => {
      await B000111Biko(methods, navigate, setMsg);
      reRendering();
    })();
  };

  // 商品コード変更
  const handleChangeShohinCd = () => {
    (async () => {
      const meiFields = meiMethods.getValues();
      if (meiFields.shohinCd === meiFields.dirtyFields?.shohinCd) return;
      await B050010HandleChangeShohinCd(methods, meiMethods, navigate, setMsg);
      reRendering();
    })();
  };

  // 倉庫コード変更
  const handleChangeSokoCd = () => {
    (async () => {
      const meiFields = meiMethods.getValues();
      if (meiFields.sokoCd === meiFields.dirtyFields?.sokoCd) return;
      await B000190SokoNmrSokoshubetsuKbn(meiMethods, navigate, setMsg);
      reRendering();
    })();
  };

  // レイアウト設定
  return (
    <>
      <FormProvider {...methods}>
        <SFrame
          title="仕入入力"
          gridTemplateColumns="6rem 10rem 1rem 5rem 10rem 5rem 1rem 6rem 10rem 10rem 10rem"
        >
          <SLabel required gridColumn="1">
            仕入日
          </SLabel>
          <SDateField
            label="仕入日"
            name="shireYmd"
            required
            {...register(1)}
            disabled={isReference}
            onBlur={() => handleChangeShireYmd()}
            onAccept={(date: string) => {
              handleChangeShireYmd(date);
            }}
          />

          <SLabel required gridColumn="1">
            仕入先
          </SLabel>
          <SNumberField
            label="仕入先コード"
            name="shireCd"
            required
            size={6}
            {...register(2)}
            onBlur={() => handleChangeShire()}
            dialog={<B000170 />}
            handleSubmit={(data: any) => {
              methods.setValue("shireCd", data.shireCd);
              // 仕入先表示
              (async () => {
                await B050010Shire(methods, navigate, setMsg);
                reRendering();
              })();
            }}
            disabled={isReference}
            code
          />
          <STextField
            name="shireNm"
            size={40}
            {...register(3)}
            gridColumn="span 4"
            disabled={!isShireShokuchi || isReference}
          />

          <SLabel gridColumn="1" required>
            仕入担当者
          </SLabel>
          <SNumberField
            label="仕入担当者コード"
            name="shainCd"
            required
            size={7}
            {...register(4)}
            onBlur={() => handleChangeShain()}
            dialog={<B000140 />}
            handleSubmit={(data: any) => {
              methods.setValue("shainCd", data.shainCd);
              methods.setValue("shainNm", data.shainNm);

              (async () => {
                await B050010Shain(methods, navigate, setMsg);
                reRendering();
              })();
            }}
            disabled={isReference}
            code
          />
          <STextField name="shainNm" disabled gridColumn="span 4" size={40} />

          <SLabel gridColumn="8">仕入担当部門</SLabel>
          <STextField name="bumonNm" disabled size={20} />

          <SLabel gridColumn="1">仕入備考</SLabel>
          <SNumberField
            name="bikoCd"
            onBlur={() => handleChangeBiko()}
            dialog={<B000111 meishoKbn={meishoKbn.biko} />}
            handleSubmit={(data: any) => {
              methods.setValue("bikoCd", data?.meishoCd);
              methods.setValue("biko", data?.meishoNm1);
              methods.setValue("bikoCdBefore", data?.meishoCd);
              reRendering();
            }}
            size={3}
            {...register(5)}
            disabled={isReference}
            code="true"
          />
          <STextField
            name="biko"
            gridColumn="span 4"
            size={40}
            {...register(6)}
            disabled={isReference}
          />

          <SLabel required gridColumn="8">
            仕入帳端
          </SLabel>
          <SCodeSelect
            label="仕入帳端"
            name="chohaKbn"
            required
            options={ChohaKbn}
            {...register(7)}
            disabled={isReference}
          />

          <SLabel gridColumn="9" gridRow="7">
            仕入金額合計
          </SLabel>
          <SLabel gridColumn="10" gridRow="7">
            消費税
          </SLabel>
          <SLabel gridColumn="11" gridRow="7">
            合計
          </SLabel>
          <SNumberField
            name="shireKinGokei"
            disabled
            align="right"
            gridColumn="9"
            gridRow="8"
            size={11}
          />
          <SNumberField
            name="zeiKinGokei"
            disabled
            align="right"
            gridColumn="10"
            gridRow="8"
            size={10}
          />
          <SNumberField
            name="gokei"
            disabled
            align="right"
            gridColumn="11"
            gridRow="8"
            size={11}
          />
        </SFrame>
      </FormProvider>
      <SFrame>
        <STable
          keyName="shiregyoNo"
          data={rows}
          columns={columns}
          totalCount={rowCount}
          tableRef={tableRef}
          width={1260}
          height={320}
          handleDoubleClick={
            isReference ? undefined : handleDoubleClickTableRow
          }
          rowSelectable={meiMethods.watch("meiTab")}
        />
      </SFrame>

      <FormProvider {...meiMethods}>
        <SFrame>
          <SEntryTab
            name="meiTab"
            handleOk={handleChangeMeiTab}
            disabled={isReference}
          ></SEntryTab>
          <SFrame gridTemplateColumns="8rem 10rem 5rem 9rem 8rem 8rem 8rem 8rem 10.5rem">
            <SLabel required>区分</SLabel>
            <SLabel required>商品コード</SLabel>
            <SLabel required gridColumn="span 2">
              倉庫
            </SLabel>

            <SLabel required>仕入数</SLabel>

            <SLabel required>仕入単価</SLabel>

            <SLabel required>仕入金額</SLabel>

            <SCodeSelect
              label="区分"
              name="uchiwakeKbn"
              required
              options={ShireUchiwakeKbn}
              {...register(8)}
              gridColumn="1"
              onChange={() => handleChangeUchiwakeKbn()}
              disabled={isReference}
            />
            <SNumberField
              label="商品コード"
              name="shohinCd"
              size={10}
              required
              {...register(9)}
              dialog={<B000200 />}
              handleSubmit={(data: any) => {
                meiMethods.setValue("shohinCd", data.shohinCd);
                meiMethods.setValue("shohinNm", data.shohinNm);
                meiMethods.setValue("shohinshokuchiKbn", data.shokuchiKbn);
                // 商品関連項目表示
                (async () => {
                  await B050010Shohin(methods, meiMethods, navigate, setMsg);
                  reRendering();
                })();
              }}
              onBlur={() =>
                // 商品コード変更
                handleChangeShohinCd()
              }
              disabled={isReference}
              code
            />
            <SNumberField
              label="倉庫コード"
              name="sokoCd"
              {...register(10)}
              size={3}
              required
              onBlur={() => handleChangeSokoCd()}
              dialog={<B000190 />}
              handleSubmit={(data: any) => {
                meiMethods.setValue("sokoCd", data?.sokoCd);
                meiMethods.setValue("sokoNm", data?.sokoNmr);
                meiMethods.setValue("sokoshubetsuKbn", data?.sokoshubetsuKbn);
                reRendering();
              }}
              disabled={isReference}
              code
            />
            <STextField name="sokoNm" disabled />

            <SNumberField
              label="仕入数"
              name="shiresu"
              size={6}
              align="right"
              required
              {...register(11)}
              disabled={isReference}
              onBlur={() => {
                handleCalcShireKin();
              }}
              dialog={<B000220 shohinCd={meiMethods.watch("shohinCd")} />}
              handleSubmit={(data: any) => {
                meiMethods.setValue("shohinCd", data.shohinCd);
                meiMethods.setValue("shohinNm", data.shohinNm);
                meiMethods.setValue("sokoCd", data.sokoCd);
                meiMethods.setValue("sokoNm", data.sokoNm);
                meiMethods.setValue("sokoshubetsuKbn", data.sokoshubetsuKbn);

                // 商品関連項目表示
                (async () => {
                  await B050010Shohin(methods, meiMethods, navigate, setMsg);
                  reRendering();
                })();
              }}
            />

            <SNumberField
              label="仕入単価"
              name="shiretanka"
              size={6}
              align="right"
              required
              {...register(12)}
              disabled={isReference}
              onBlur={() => {
                handleCalcShireKin();
              }}
            />

            <SNumberField
              label="仕入金額"
              name="shireKin"
              required
              size={6}
              align="right"
              {...register(13)}
              disabled
            />

            <SLabel gridColumn="1/5">商品名</SLabel>
            <SLabel gridColumn="5/10">仕入明細備考</SLabel>
            <STextField
              name="shohinNm"
              size={40}
              gridColumn="span 4"
              {...register(14)}
              disabled={!isShohinShokuchiKbn || isReference}
            />

            <SNumberField
              name="meisaibikoCd"
              {...register(15)}
              size={3}
              onBlur={() => B000111Meisaibiko(meiMethods, navigate, setMsg)}
              dialog={<B000111 meishoKbn="7" />}
              handleSubmit={(data: any) => {
                meiMethods.setValue("meisaibikoCd", data?.meishoCd);
                meiMethods.setValue("meisaibiko", data?.meishoNm1);
                meiMethods.setValue("meisaibikoCdBefore", data?.meishoCd);
                reRendering();
              }}
              gridColumn="5/6"
              disabled={isReference}
              code="true"
            />
            <STextField
              name="meisaibiko"
              size={30}
              gridColumn="6/10"
              {...register(16)}
              disabled={isReference}
            />

            <SCancelButton
              label={labels.buttons.deleteDetail}
              {...register(17)}
              gridRow="7"
              gridColumn="1"
              onClick={handleClickDeleteMeiButton}
              disabled={disabledDeleteDetail}
            />
            {meiMethods.watch("meiTab") ? (
              <SNormalButton
                label={labels.buttons.createDetail}
                {...register(18)}
                gridRow="7"
                gridColumn="9"
                align="right"
                onClick={handleClickCreateMeiButton}
                disabled={isReference}
              />
            ) : (
              <SNormalButton
                label={labels.buttons.updateDetail}
                {...register(18)}
                gridRow="7"
                gridColumn="9"
                align="right"
                onClick={handleClickUpdateMeiButton}
              />
            )}
          </SFrame>
          <SFrame gridTemplateColumns="7rem 68rem 4rem">
            <SCancelButton
              label={labels.buttons.delete}
              gridColumn={1}
              {...register(19)}
              disabled={!isUpdate}
              dialog={
                <SConfirmDialog
                  title="仕入データ削除"
                  msg="仕入データを削除します。よろしいですか？"
                />
              }
              dialogAction="confirm"
              handleSubmit={handleClickDeleteButton}
            />
            {!isReference && (
              <>
                {methods.getValues().shiredenpyoNo === "" ? (
                  <SNormalButton
                    label={labels.buttons.create}
                    align="right"
                    {...register(20)}
                    onClick={() => handleOpenCreateConfirm()}
                  />
                ) : (
                  <SNormalButton
                    label={labels.buttons.update}
                    align="right"
                    {...register(21)}
                    onClick={() => handleOpenUpdateConfirm()}
                  />
                )}
              </>
            )}
          </SFrame>
        </SFrame>
        <SConfirmDialogAction
          msg={labels.dialog.createCheck}
          onOk={handleClickCreateButton}
          onCancel={handleCancelCreateConfirm}
          isOpen={openCreateConfirm}
        />
        <SConfirmDialogAction
          msg={labels.dialog.updateCheck}
          onOk={handleClickUpdateButton}
          onCancel={handleCancelUpdateConfirm}
          isOpen={openUpdateConfirm}
        />
      </FormProvider>
    </>
  );
};
